import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from "react-router-dom";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { message, Button, Card, Divider, Drawer, Form, Input, Layout, Select, Tabs, Tooltip } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import EditQuiz from "../../Modals/Quizzes/EditQuiz/EditQuiz";
import QuestionList from "./QuestionList";
import QuizGrades from "./QuizGrades";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useListVals } from "../../Firebase/databaseHooks";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";

const { TextArea } = Input;
const { TabPane } = Tabs;
const moment = require("moment");
var db = getDatabase(Firebase);
const QuizDetails = () => {

	const { id } = useParams();
	const { canAccessModule } = useAuth();
	const canCreateQuiz = canAccessModule("QUIZZES", "create");
	const canUpdateQuiz = canAccessModule("QUIZZES", "update");
	const canDeleteQuiz = canAccessModule("QUIZZES", "delete");
	const location = useLocation();
	const [checkedData, setCheckedData] = useState(false);
	const [quiz, setQuiz] = useState(location.state.quiz);
	const [addModal, setAddModal] = useState(false);
	const [count, setCount] = useState(0);
	const [questions] = useListVals(ref(db, `talmidsdb/quizzes/${id}/questions`));
	const [questionArray, setQuestionArray] = useState([]);
	const [questionForm] = Form.useForm();

	useEffect(() => {
		if (location.state.quiz === undefined) {
			window.location.href = "/quizzes"
		} else {
			setQuiz(location.state.quiz);
			var tempArray = [];
			if (questions) {
				setQuestionArray([...questions]);
			}
		}

	}, [id, location.state.quiz, questions])

	const callback = (data) => {
		setCheckedData(data);
	}
	const getOptionArray = (number) => {
		var num = parseInt(number);
		var arry = [];
		for (var i = 0; i < num; i++) {
			arry.push({
				"name": `option-${i + 1}`, "optionID": Array(6).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
					.map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('')
			});
		}
		return arry;
	}

	const addQuestion = (values) => {
		if (!canCreateQuiz) {
			message.error("You do not have permission to create quiz questions.");
			return;
		}

		var questionIndex = questionArray.filter(Boolean).length + 1;
		var questionID = Array(12).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789")
			.map(x => x[Math.floor(Math.random() * x.length)]).join('');
		var questionObject = values;
		questionObject.quizID = id;
		questionObject.id = questionID;
		questionObject.questionIndex = questionIndex;
		questionObject.timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");

		const path = `quizzes/${id}/questions`;
		const output = FireFetch.SaveTODB(path, questionID, questionObject);
		output.then((result) => {
			if (result === "success") {
				FireFetch.addLog("QuizQuestions", questionID, "Create");
				message.success("Question created successfully");
				questionForm.resetFields();
				setCount(0);
			} else {
				message.error("Unable to create Question");
			}
		});
	}

	return (
		<>
			<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
				<Drawer
					title="Add Question"
					width={500}
					maskClosable
					placement="right"
					onClose={() => { setAddModal(false) }}
					visible={addModal}
					footer={
						<>
							<Button id="btnSubmit" form="questionForm" type="primary" htmlType="submit" className="mb-3">
								Add Question
							</Button>
						</>
					}
					className="font-Nunito"
				>
					{
						<Form
							layout="vertical"
							id={"questionForm"}
							form={questionForm}
							onFinish={addQuestion}
						>
							<Form.Item label="Question"
								name="question"
								rules={[{ required: true }]}
							>
								<TextArea placeholder={"enter question"} id={"AddedQ"} />
							</Form.Item>
							<Form.List name="options">
								{(fields, { add, remove }) => {
									return (
										<div>
											{fields.map((field, index) => (
												<Form.Item
													label={index === 0 ? 'Options' : ''}
													required={false}
													key={field.key}
												>
													<Form.Item
														{...field}
														validateTrigger={['onChange', 'onBlur']}
														rules={[
															{
																required: true,
																whitespace: true,
																message: "Please input option text",
															},
														]}
														noStyle
													>
														<Input
															placeholder="enter option text"
															style={{
																width: '75%',
															}}
														/>
													</Form.Item>
													{fields.length > 0 ? (
														<Tooltip title="Remove option">
															<Button type="danger"
																shape="circle"
																icon={<MinusCircleOutlined />}
																className="dynamic-delete-button mx-2"
																onClick={() => {
																	setCount(count - 1);
																	remove(field.name);
																}} />
														</Tooltip>
													) : null}
												</Form.Item>
											))}
											<Divider />
											<Form.Item>
												<Button
													type="dashed"
													onClick={() => {
														setCount(count + 1);
														add();
													}}
													style={{ width: "40%" }}
												>
													<PlusOutlined /> Add Option
												</Button>
											</Form.Item>
										</div>
									);
								}}
							</Form.List>
							<Form.Item label="Correct Answer"
								name="answer"
								rules={[
									{
										required: true,
										message: "Please input correct answer",
									},
								]}
							>
								<Select placeholder="Select correct option" id={"correctAns-"}
								>
									{getOptionArray(count).map((item, index) => (
										<Select.Option key={index} value={index}>{item.name}</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Form>
					}
				</Drawer>
				<MDBRow className="w-100">
					<MDBCol md={12}>
						<Card className="w-100">
							<MDBRow>
								<MDBCol md={12}>
									<div className="text-left">
										<div className="d-flex flex-row justify-content-between">
											<div className="d-inline">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														Quiz : {quiz.title}
													</Text>
												</h5>
											</div>
										</div>
									</div>
								</MDBCol>
							</MDBRow>
						</Card>
						<Card>
							<Tabs defaultActiveKey="1" type="card" size={"normal"}>
								<TabPane tab="Details" key="1">
									<div className="pr-5">
										<EditQuiz quiz={quiz} canUpdateQuiz={canUpdateQuiz} />
									</div>
								</TabPane>
								<TabPane tab="Questions" key="2">
									<div className="d-flex justify-content-end my-1">
										{canCreateQuiz && (
											<Button type="primary" onClick={() => {
												setAddModal(true);
											}}>
												Add Question
											</Button>
										)}
									</div>
									<Divider />
									<div>
										<QuestionList
											quizID={id}
											canUpdateQuiz={canUpdateQuiz}
											canDeleteQuiz={canDeleteQuiz}
										/>
									</div>
								</TabPane>
								<TabPane tab="Attempts" key="3">
									<div>
										<QuizGrades quizID={id} />
									</div>
								</TabPane>
							</Tabs>
						</Card>
					</MDBCol>
				</MDBRow>
			</div>
		</>
	);
}

export default QuizDetails;
